import { SerializedConstructor } from '@langchain/core/load/serializable';

import { getModelFromManifest } from '@/Pages/Playground/utils/Playground.utils';

import { ModelConfig } from '../ModelConfig';
import { JsonMessageDiff } from './Diffs';
import { GetModelConfigDiffsArgs, StoredModelConfigDiffsRecord } from './types';

export const CommitModelConfig = ({
  commitId,
  showDiff,
  currentCommitManifest,
  previousCommitManifest,
  getModelConfigDiffs,
}: {
  commitId: string;
  showDiff: boolean;
  currentCommitManifest: SerializedConstructor;
  previousCommitManifest?: SerializedConstructor;
  getModelConfigDiffs: (
    args: GetModelConfigDiffsArgs
  ) => StoredModelConfigDiffsRecord;
}) => {
  const previousModel = previousCommitManifest
    ? getModelFromManifest(previousCommitManifest) ?? undefined
    : undefined;
  const model = getModelFromManifest(currentCommitManifest) ?? undefined;

  const { modelConfigDiffs } = getModelConfigDiffs({
    commitId,
    previousCommitModelConfig: previousModel,
    currentCommitModelConfig: model,
  });

  return showDiff ? (
    model || previousModel ? (
      <JsonMessageDiff diffs={modelConfigDiffs} title="Model Configuration" />
    ) : null
  ) : model ? (
    <ModelConfig model={model} hideTools />
  ) : null;
};
